var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 109,
    viewBox: "0 0 157 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 156,
    height: 108,
    rx: 3.5,
    stroke: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 30,
    width: 105,
    height: 3,
    rx: 1.5,
    fill: "#727272"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 60,
    width: 105,
    height: 3,
    rx: 1.5,
    fill: "#727272"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 105,
    height: 3,
    rx: 1.5,
    fill: "#727272"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 72,
    width: 49,
    height: 3,
    rx: 1.5,
    fill: "#727272"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 36,
    width: 105,
    height: 3,
    rx: 1.5,
    fill: "#727272"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 66,
    width: 49,
    height: 3,
    rx: 1.5,
    fill: "#727272"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 48,
    width: 59,
    height: 3,
    rx: 1.5,
    fill: "#727272"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 78,
    width: 49,
    height: 3,
    rx: 1.5,
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeform);
export default __webpack_public_path__ + "static/media/freeform.ffc35e7768dec5133437238efcadbeb1.svg";
export { ForwardRef as ReactComponent };